"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[814],{

/***/ 60814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DV": function() { return /* reexport */ AuthorAvatar; },
  "d7": function() { return /* reexport */ AuthorInfo; },
  "U2": function() { return /* reexport */ Author_AuthorName; },
  "a6": function() { return /* reexport */ Author_AuthorPosition; },
  "XY": function() { return /* reexport */ TestimonialBase; },
  "hC": function() { return /* reexport */ BaseAuthorSlot; },
  "b6": function() { return /* reexport */ BaseContentSlot; },
  "jo": function() { return /* reexport */ BaseLogo; },
  "k$": function() { return /* reexport */ BaseText; },
  "jW": function() { return /* reexport */ Extended; },
  "Di": function() { return /* reexport */ ExtendedButton; },
  "Wi": function() { return /* reexport */ ExtendedButtonSlot; },
  "S2": function() { return /* reexport */ ExtendedHeader; },
  "Jk": function() { return /* reexport */ ExtendedHeaderSup; },
  "c9": function() { return /* reexport */ ExtendedStoryLink; },
  "wN": function() { return /* reexport */ ExtendedText; },
  "VJ": function() { return /* reexport */ ExtendedTextSlot; },
  "ZP": function() { return /* reexport */ Testimonial; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Testimonial.views.ts


var TestimonialWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "etkcvo80"
} : 0)("overflow:hidden;border-radius:", function (_ref) {
  var borderRadius = _ref.borderRadius;
  return borderRadius;
}, ";background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";display:", function (_ref3) {
  var display = _ref3.display;
  return display;
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:", function (_ref5) {
  var desktopGridTemplateColumns = _ref5.desktopGridTemplateColumns;
  return desktopGridTemplateColumns;
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Testimonial.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseTestimonial = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var animationState = {
    initial: {
      position: "relative",
      opacity: 0
    },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.75
      }
    },
    exit: {
      position: "absolute",
      top: 0,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, _objectSpread(_objectSpread({}, animationState), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialWrapper, _objectSpread(_objectSpread(_objectSpread({
      elevation: 3,
      ref: ref
    }, tokens), rest), {}, {
      children: children
    }))
  }));
});
var Testimonial = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTestimonial, function (_ref2, theme) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "base" : _ref2$variant;
  return _objectSpread({
    borderRadius: "20px 20px 100px 20px"
  }, variant === "extended" && {
    borderRadius: "20px",
    background: theme.palette.neutrals.white[100],
    display: "grid",
    desktopGridTemplateColumns: "60% 40%"
  });
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Base/Base.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var BaseAuthorSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep56rpo4"
} : 0)( true ? {
  name: "1ldl4ze",
  styles: "display:grid;grid-auto-flow:column;justify-content:flex-start;align-items:center;column-gap:16px"
} : 0);
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep56rpo3"
} : 0)("display:grid;align-content:space-between;padding-top:48px;padding-bottom:48px;padding-left:24px;padding-right:24px;", function (_ref) {
  var overrides = _ref.overrides;
  return overrides;
}, " border-radius:20px 20px 100px 20px;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";height:", function (_ref3) {
  var height = _ref3.height;
  return height;
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("sm");
}, "{padding-left:32px;padding-right:48px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{padding-left:48px;padding-right:64px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{min-height:", function (_ref7) {
  var height = _ref7.height;
  return height;
}, ";padding-right:80px;}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("xl");
}, "{padding-right:120px;}" + ( true ? "" : 0));
var BaseLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep56rpo2"
} : 0)( true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0);
var BaseContentSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep56rpo1"
} : 0)( true ? "" : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ep56rpo0"
} : 0)("color:", function (_ref9) {
  var color = _ref9.color;
  return color;
}, ";mark{background-color:transparent;color:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.twilio.mint[100];
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Base/Base.tsx


var Base_excluded = ["children", "overrides", "tokens"],
    _excluded2 = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BaseTestimonialBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      overrides = _ref.overrides,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  var overridesCss = useCssWithOverrides(overrides);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref,
    overrides: overridesCss
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: "dark",
      children: children
    })
  }));
});
var TestimonialBase = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTestimonialBase, function (_ref2) {
  var _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? "640px" : _ref2$height;
  return {
    height: height
  };
}, {
  light: function light(theme) {
    return {
      background: "linear-gradient(\n        77.14deg,\n        ".concat((0,polished_esm/* transparentize */.DZ)(0.6, theme.palette.brand.boysenberry[600]), " 0%,\n        ").concat(theme.palette.brand.boysenberry[600], " 100%\n      ),\n      ").concat(theme.palette.brand.darkAcai[700], ";")
    };
  },
  dark: function dark(theme) {
    return {
      background: "linear-gradient(\n        77.14deg,\n        ".concat((0,polished_esm/* transparentize */.DZ)(0.6, theme.palette.brand.boysenberry[600]), " 0%,\n        ").concat(theme.palette.brand.boysenberry[600], " 100%\n      ),\n      ").concat(theme.palette.brand.darkAcai[700], ";")
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.blue[70]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      background: theme.palette.twilio.gray[100]
    };
  }
});

var useCssWithOverrides = function useCssWithOverrides(overrides) {
  var overridesCss = (0,react.useMemo)(function () {
    var keys = [];

    for (var key in overrides) {
      keys.push(key);
    }

    var overridesCss =
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)( true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);

    if (overrides) {
      overridesCss =
      /*#__PURE__*/

      /*#__PURE__*/
      (0,emotion_react_browser_esm/* css */.iv)(keys === null || keys === void 0 ? void 0 : keys.map(function (key) {
        return (
          /*#__PURE__*/

          /*#__PURE__*/
          (0,emotion_react_browser_esm/* css */.iv)(Theme/* default.breakpoints.up */.ZP.breakpoints.up(key), "{", overrides[key], ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
        );
      }), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
    }

    return overridesCss;
  }, [overrides]);
  return overridesCss;
};

var Text = function Text(_ref3) {
  var children = _ref3.children,
      tokens = _ref3.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, Base_objectSpread(Base_objectSpread(Base_objectSpread({
    variant: "h4",
    tag: "p"
  }, tokens), rest), {}, {
    children: children
  }));
};

var BaseText = (0,useDesignTokens/* withDesignTokens */.Y)(Text, function (_props, theme) {
  return {
    color: theme.palette.neutrals.white[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Base/index.ts


// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Author/Author.views.ts


function Author_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var AuthorAvatar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1lsnmnr3"
} : 0)("width:48px;height:48px;border-radius:50%;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{width:60px;height:60px;}" + ( true ? "" : 0));
var AuthorInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lsnmnr2"
} : 0)( true ? "" : 0);
var AuthorName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1lsnmnr1"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var AuthorPosition = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1lsnmnr0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Author/Author.tsx


var Author_excluded = ["children", "tokens"],
    Author_excluded2 = ["children", "tokens"];

function Author_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Author_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Author_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Author_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseAuthorName = function BaseAuthorName(_ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Author_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorName, Author_objectSpread(Author_objectSpread({
    tokens: tokens,
    variant: "pMedium"
  }, rest), {}, {
    children: children
  }));
};
var Author_AuthorName = (0,useDesignTokens/* withDesignTokens */.Y)(BaseAuthorName, function (_, theme) {
  return {
    color: theme.palette.neutrals.white[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});

var BaseAuthorPosition = function BaseAuthorPosition(_ref2) {
  var children = _ref2.children,
      tokens = _ref2.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, Author_excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorPosition, Author_objectSpread(Author_objectSpread({
    tokens: tokens,
    variant: "textTiny"
  }, rest), {}, {
    children: children
  }));
};

var Author_AuthorPosition = (0,useDesignTokens/* withDesignTokens */.Y)(BaseAuthorPosition, function (_, theme) {
  return {
    color: (0,polished_esm/* transparentize */.DZ)(0.3, theme.palette.neutrals.white[100])
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Author/index.ts


// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Extended/Extended.views.ts


function Extended_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Extended_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14dg3xm6"
} : 0)("display:grid;align-content:space-between;background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";padding:32px 24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{padding:48px 32px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("md");
}, "{padding:48px;}" + ( true ? "" : 0));
var ExtendedTextSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14dg3xm5"
} : 0)( true ? "" : 0);
var ExtendedButtonSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14dg3xm4"
} : 0)( true ? "" : 0);
var ExtendedHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14dg3xm3"
} : 0)("font-family:var(--fontFamily, ", Theme/* whitneyFont */.IG, ");color:", function (_ref5) {
  var color = _ref5.color;
  return color;
}, ";font-weight:600;font-size:56px;line-height:56px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("sm");
}, "{font-size:64px;line-height:64px;}", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("md");
}, "{font-size:68px;line-height:68px;}" + ( true ? "" : 0));
var ExtendedHeaderSup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("sup",  true ? {
  target: "e14dg3xm2"
} : 0)("font-family:var(--fontFamily, ", Theme/* whitneyFont */.IG, ");font-weight:600;font-size:32px;line-height:40px;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("md");
}, "{font-size:40px;line-height:48px;}" + ( true ? "" : 0));
var ExtendedStoryLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14dg3xm1"
} : 0)("display:grid;justify-content:end;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.down("md");
}, "{justify-content:start;}" + ( true ? "" : 0));
var Extended_views_ExtendedText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e14dg3xm0"
} : 0)( true ? {
  name: "e5q3zu",
  styles: "color:currentColor;margin-bottom:40px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Extended/Extended.tsx


var Extended_excluded = ["children", "tokens"],
    Extended_excluded2 = ["children", "variant"];

function Extended_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Extended_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Extended_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Extended_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseExtended = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Extended_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Extended_views_Wrapper, Extended_objectSpread(Extended_objectSpread(Extended_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Extended = (0,useDesignTokens/* withDesignTokens */.Y)(BaseExtended, function (_, theme) {
  return {
    background: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[600]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.boysenberry[600]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.blue[60]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
var ExtendedText = function ExtendedText(_ref2) {
  var children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "h4" : _ref2$variant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, Extended_excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Extended_views_ExtendedText, Extended_objectSpread(Extended_objectSpread({
    variant: variant,
    tag: "p"
  }, rest), {}, {
    children: children
  }));
};
var ExtendedButton = function ExtendedButton(_ref3) {
  var href = _ref3.href,
      text = _ref3.text,
      colored = _ref3.colored,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? "medium" : _ref3$size;
  var regex = /^http/;
  var variant = colored ? "mono" : "brand";
  return regex.test(href) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
    tag: "a",
    href: href,
    size: size,
    appearance: "twilioLight",
    variant: variant,
    iconEnd: Common/* ChevronRightIcon */.XC,
    children: text
  }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
      tag: "span",
      size: size,
      appearance: "twilioLight",
      variant: variant,
      iconEnd: Common/* ChevronRightIcon */.XC,
      children: text
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/Extended/index.ts


;// CONCATENATED MODULE: ../../libs/matcha/recipes/Testimonial/index.ts




Testimonial.displayName = "TestimonialBase";
TestimonialBase.displayName = "Testimonial.Base";
BaseLogo.displayName = "Testimonial.BaseLogo";
BaseContentSlot.displayName = "Testimonial.BaseContentSlot";
BaseText.displayName = "Testimonial.BaseText";
BaseAuthorSlot.displayName = "Testimonial.BaseAuthorSlot";
AuthorAvatar.displayName = "Testimonial.AuthorAvatar";
AuthorInfo.displayName = "Testimonial.AuthorInfo";
Author_AuthorName.displayName = "Testimonial.AuthorName";
Author_AuthorPosition.displayName = "Testimonial.AuthorPosition";
Extended.displayName = "Testimonial.Extended";
ExtendedTextSlot.displayName = "Testimonial.ExtendedTextSlot";
ExtendedButtonSlot.displayName = "Testimonial.ExtendedButtonSlot";
ExtendedText.displayName = "Testimonial.ExtendedText";
ExtendedHeader.displayName = "Testimonial.ExtendedHeader";
ExtendedHeaderSup.displayName = "Testimonial.ExtendedHeaderSup";
ExtendedStoryLink.displayName = "Testimonial.ExtendedStoryLink";
ExtendedButton.displayName = "Testimonial.ExtendedButton";





/***/ })

}]);